/**
 * Picks the half of a react-hook-form resolver result that validation calls for: a result carries
 * either the accepted values or the errors, never both. Pass the values the form should submit —
 * a normalised copy is fine — and whatever errors validation produced.
 */
export const toResolverResult = (values, errors) => (Object.keys(errors).length > 0 ? { values: {}, errors } : { values, errors: {} });
